import { useEffect } from "react";
import { useSettingsValueData } from "./useSettingsValueData";

export function useTitle(title?: string) {
  const settings = useSettingsValueData();
  const partnerName = settings.data.partnerName ?? "PARTNER NAME";

  useEffect(() => {
    const prevTitle = document.title;

    /* eslint-disable-next-line functional/immutable-data */
    document.title = `${partnerName} ${title ?? ""}`;

    return () => {
      /* eslint-disable-next-line functional/immutable-data */
      document.title = prevTitle;
    };
  });
}
